import React, { useState } from 'react';
import { MdFilterList, MdSearch, MdClear } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import PortalFormModal from './PortalFormModal';
import { usePortal, useSelecao } from '../hooks';
function FiltersModal({ filters, selections, onClose, onFilter }) {
  const { labels } = usePortal();
  const [selection, setSelection] = useState(filters.selection_id || '');
  const query = useSelecao(selection);
  return (
    <PortalFormModal
      title="Filtrar inscrições"
      description="Escolha os critérios para a listagem e as operações em lote."
      icon={<MdFilterList />}
      onClose={onClose}
      requiredNote={false}
      submitText="Aplicar filtros"
      submitIcon={<MdFilterList />}
      onSubmit={(event) => {
        const data = Object.fromEntries(new FormData(event.currentTarget));
        onClose();
        onFilter({ ...filters, ...data, page: undefined });
      }}
    >
      <div className="portal-admin-grid">
        <label className="form-label">
          <span>{labels.selection}</span>
          <select
            className="form-control form-select"
            name="selection_id"
            value={selection}
            onChange={(e) => setSelection(e.target.value)}
          >
            <option value="">Todos</option>
            {selections?.map((s) => (
              <option key={s.id} value={s.id}>
                {s.title}
              </option>
            ))}
          </select>
        </label>
        <label className="form-label">
          <span>Situação da inscrição</span>
          <select name="status" className="form-control form-select" defaultValue={filters.status}>
            <option value="">Todas</option>
            {[
              ['draft', 'Rascunho'],
              ['under_review', 'Em análise'],
              ['documents_pending', 'Documentos pendentes'],
              ['approved', 'Deferida'],
              ['rejected', 'Indeferida'],
              ['cancelled', 'Cancelada'],
            ].map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="portal-admin-grid portal-advanced-filters">
        <label className="form-label">
          <span>{labels.position}</span>
          <select
            key={selection}
            className="form-control form-select"
            name="position_id"
            defaultValue={selection === filters.selection_id ? filters.position_id || '' : ''}
          >
            <option value="">Todos</option>
            {query.data?.positions?.map((position) => (
              <option key={position.id} value={position.id}>
                {position.title}
              </option>
            ))}
          </select>
        </label>
        {[
          ['name', 'Nome'],
          ['cpf', 'CPF'],
          ['email', 'E-mail'],
          ['number', 'Inscrição ou protocolo'],
        ].map(([name, label]) => (
          <label className="form-label" key={name}>
            <span>{label}</span>
            <input className="form-control" name={name} defaultValue={filters[name]} />
          </label>
        ))}
        <label className="form-label">
          <span>Documentos</span>
          <select
            name="document_status"
            className="form-control form-select"
            defaultValue={filters.document_status}
          >
            <option value="">Todos</option>
            {[
              ['missing', 'Não enviados'],
              ['pending', 'Em análise'],
              ['approved', 'Aprovados'],
              ['rejected', 'Recusados'],
            ].map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>
        <label className="form-label">
          <span>Cadastro na OnTest</span>
          <select
            name="integration_status"
            className="form-control form-select"
            defaultValue={filters.integration_status}
          >
            <option value="">Todos</option>
            {[
              ['not_requested', 'Não solicitado'],
              ['pending', 'Pendente'],
              ['processing', 'Processando'],
              ['synced', 'Concluído'],
              ['failed', 'Falha'],
            ].map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>
        {[
          ['from', 'Recebida a partir de'],
          ['to', 'Recebida até'],
        ].map(([name, label]) => (
          <label className="form-label" key={name}>
            <span>{label}</span>
            <input className="form-control" name={name} type="date" defaultValue={filters[name]} />
          </label>
        ))}
        <label className="form-label">
          <span>Ordenação</span>
          <select
            className="form-control form-select"
            name="sort"
            defaultValue={filters.sort || 'newest'}
          >
            <option value="newest">Mais recentes</option>
            <option value="oldest">Mais antigas</option>
            <option value="name">Nome</option>
            <option value="number">Inscrição</option>
          </select>
        </label>
      </div>
    </PortalFormModal>
  );
}
export default function ApplicationFilters({ filters, selections, onFilter }) {
  const [open, setOpen] = useState(false);
  const count = Object.entries(filters).filter(
    ([key, value]) =>
      !['busca', 'page'].includes(key) && value && !(key === 'sort' && value === 'newest')
  ).length;
  return (
    <div className="portal-filters hidethis">
      <form
        className="portal-admin-form portal-search-form"
        aria-label="Pesquisar inscrições"
        onSubmit={(event) => {
          event.preventDefault();
          const data = new FormData(event.currentTarget);
          onFilter({ ...filters, busca: data.get('busca'), page: undefined });
        }}
      >
        <label htmlFor="portal-application-search" className="form-label">
          Pesquisar inscrições
        </label>
        <div className="portal-filter-toolbar">
          <div className="portal-search-input">
            <input
              id="portal-application-search"
              className="form-control"
              name="busca"
              defaultValue={filters.busca}
              placeholder="Nome, CPF ou e-mail"
            />
            <button
              type="submit"
              className="btn portal-search-button hidethis"
              aria-label="Pesquisar"
              title="Pesquisar"
            >
              <MdSearch size={20} aria-hidden="true" />
            </button>
          </div>
          <DefaultButton
            text={count ? 'Filtros (' + count + ')' : 'Filtros'}
            bg="primary"
            icon={<MdFilterList />}
            onClick={() => setOpen(true)}
          />
          {(count > 0 || filters.busca) && (
            <DefaultButton
              text="Limpar filtros"
              bg="secondary"
              icon={<MdClear />}
              onClick={() => onFilter({})}
            />
          )}
        </div>
      </form>
      {open && (
        <FiltersModal
          filters={filters}
          selections={selections}
          onClose={() => setOpen(false)}
          onFilter={onFilter}
        />
      )}
    </div>
  );
}
